import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthService } from 'src/app/service/auth.service';
import { CommonService } from 'src/app/service/common.service';
import { TranslationService } from 'src/app/service/translation.service';
import { CountryPickerComponent } from '../country-picker/country-picker.component';
import { Country } from 'src/app/models/country.model';
import { constants } from 'src/app/utils/constant';

@Component({
    selector: 'app-mobile-input',
    templateUrl: './mobile-input.component.html',
    styleUrls: ['./mobile-input.component.css'],
    standalone: false
})
export class MobileInputComponent {
  @Output() onOTPRequest = new EventEmitter();
  @Output() phoneNumber = new EventEmitter();
  mobilePattern = constants.mobileNumberPattern;
  countryCode:string = ''
  phone:string = ''
  selectedCountry: Country | null = null;

  constructor(public authService: AuthService, public commonService: CommonService, public translationService: TranslationService){

  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
  }

  /**
   * Handle country selection from country picker
   */
  onCountrySelected(country: Country): void {
    this.selectedCountry = country;
    this.countryCode = country.country_code;
  }

  getVerificationCode (form: any) {
    // this.onOTPRequest.emit(true);
    //       this.phoneNumber.emit(`${form.value.country_code} ${form.value.phone}`)
    if(form.valid){
      let getOtpObject = {
        country_code: this.countryCode,
        phone: form.value.phone
      }
      this.authService.getOTP(getOtpObject).subscribe((resp: any) => {
        if(resp){
          this.onOTPRequest.emit(true);
          this.phoneNumber.emit(`${this.countryCode} ${form.value.phone}`)
        }
      })
    }
}

}
